export default "__VITE_ASSET__0a087cfc__"